import React, { memo, useCallback, useMemo } from 'react';
import { SimpleTag as Tag } from '@atlaskit/tag';
import { useIntl } from '@atlassian/jira-intl';
import { DateOnly } from '@atlassian/jira-platform-utils-date-only/src/index.tsx';

export type Props = {
	archivedDate: string;
};

const DATE_FORMAT_OPTIONS = {
	day: 'numeric',
	month: 'short',
	year: 'numeric',
} as const;

const DateCell = memo<Props>(({ archivedDate }: Props) => {
	const { formatDate: formatDateIntl } = useIntl();
	const formatDate = useCallback(
		(date: DateOnly | null) =>
			date ? formatDateIntl(date.toLocalDate(), DATE_FORMAT_OPTIONS) : '',
		[formatDateIntl],
	);

	const dateOnlyInstance = archivedDate.split('T')[0];

	const currentValue = useMemo(
		() =>
			formatDate(dateOnlyInstance !== null ? DateOnly.fromISODateString(dateOnlyInstance) : null),
		[dateOnlyInstance, formatDate],
	);

	return <Tag text={currentValue} color="standard" />;
});

export default DateCell;
